<template>
  <div>
    <Breadcrumbs main="fleet" title="car informations" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-xl-12 xl-100">
          <b-card header-tag="div" no-body>
            <h5 slot="header">Car informations</h5>
            <b-card-body>
              <b-tabs pills slot="header" class="tabbed-card">
                <b-tab title="Car details" active>
                  <form
                    class="form theme-form"
                    @submit.prevent
                    v-if="singleCar"
                  >
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Car registration plate</label>
                            <b-form-input
                              type="text"
                              placeholder="Ex. KR7VC21"
                              v-model="singleCar.regPlate"
                            ></b-form-input>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Car owner</label>
                            <b-form-input
                              type="text"
                              placeholder="Ex. BNP Paribas Leasing"
                              v-model="singleCar.owner"
                            ></b-form-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Make</label>
                            <b-form-input
                              type="text"
                              placeholder="ex. Toyota"
                              v-model="singleCar.model"
                              required
                            ></b-form-input>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Model</label>
                            <b-form-input
                              type="text"
                              placeholder="ex. Yaris"
                              v-model="singleCar.make"
                              required
                            ></b-form-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Insurance company</label>
                            <b-form-input
                              type="text"
                              placeholder="ex. TUW S.A"
                              v-model="singleCar.insuranceCompany"
                              required
                            ></b-form-input>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Insurance number</label>
                            <b-form-input
                              type="text"
                              placeholder="ex. PL107/214/12331"
                              v-model="singleCar.insuranceNumber"
                              required
                            ></b-form-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Current mileage</label>
                            <b-form-input
                              type="number"
                              placeholder="ex. 1233"
                              v-model="singleCar.mileage"
                              required
                            ></b-form-input>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Color</label>
                            <b-form-select
                              type="s"
                              v-model="singleCar.color"
                              :options="colors"
                            ></b-form-select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Inurance expiry</label>
                            <b-form-input
                              type="date"
                              placeholder="Choose date"
                              v-model="singleCar.insuranceExpiry"
                              required
                            ></b-form-input>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Maintance date</label>
                            <b-form-input
                              type="date"
                              placeholder="Choose date"
                              v-model="singleCar.maitenanceDate"
                              required
                            ></b-form-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Registration document number</label>
                            <b-form-input
                              type="text"
                              v-model="singleCar.regDocNumber"
                              required
                            ></b-form-input>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Driving system</label>
                            <b-form-select
                              placeholder="Kowalski"
                              v-model="singleCar.currentSystem"
                              :options="options"
                            ></b-form-select>
                          </div>
                        </div>
                      </div>
                      <div class="media">
                        <label
                          class="col-form-label m-r-10"
                          v-b-tooltip.hover
                          title="By selecting this option, the car will not be available
                      for rent until the availability option is deselected
                      again."
                          id="usertip"
                          >Not available
                          <b-badge variant="primary">Info</b-badge></label
                        >

                        <div class="media-body text-right">
                          <label class="switch">
                            <input
                              type="checkbox"
                              v-model="singleCar.notAvailable"
                            /><span class="switch-state"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <b-button
                        type="submit"
                        @click="updateCar"
                        variant="primary"
                        class="mr-1"
                        >Update</b-button
                      >
                      <b-button type="reset" variant="light">Cancel</b-button>
                    </div>
                  </form>
                </b-tab>
                <b-tab title="Car maitenance">
                  <div class="row"></div>
                </b-tab>
                <b-tab title="Rental history" @click="fetchHistory">
                  <div class="row">
                    <div class="col-md-12">
                      <b-row>
                        <b-col md="6">
                          <b-input-group class="datatable-btn">
                            <b-form-input
                              v-model="filter"
                              placeholder="Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!filter" @click="filter = ''"
                                >Clear</b-button
                              >
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>

                        <b-col md="6">
                          <b-form-group
                            label-cols="2"
                            label="Per page"
                            class="mb-0 datatable-select"
                          >
                            <b-form-select
                              v-model="perPage"
                              :options="pageOptions"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          stacked="md"
                          :items="carRentalHistory"
                          :fields="tablefields"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          v-if="!isLoading && carRentalHistory"
                        >
                        </b-table>
                      </div>

                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                      ></b-pagination>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Car damage">
                  <div class="row">
                    <b-col cols="4">
                      <img
                        ref="imgRef"
                        src="../../assets/images/cars/damagechart.jpg"
                        style="max-width:100%"
                        @click="showMarkerArea"
                      />
                    </b-col>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
  </div>
</template>

<script>
import * as markerjs2 from "markerjs2";
export default {
  data() {
    return {
      isLoading: false,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      options: [
        { value: null, text: "Please select driving system" },
        { value: "3Z", text: "3 shifts system" },
        { value: "2Z", text: "2 shifts system" },
        { value: "SOLO", text: "Solo shift system" },
      ],
      colors: ["White", "Black", "Brown", "Yellow", "Blue"],
      damageChart: null,
      tablefields: [
        { key: "regPlate", label: "Registration" },
        { key: "fullName", label: "Name" },
        { key: "date", label: "Start" },
        { key: "endDate", label: "End" },
        { key: "drivingSystem", label: "Driving sytem" },
      ],
    };
  },
  created() {
    this.fetchShifts();
    this.config = {
      font: { name: "Verdana", italic: true },
    };
  },
  mounted() {
    this.loadMarkerCurrent();
  },
  computed: {
    singleCar() {
      return !this.isLoading && this.$store.getters["cars/getSingle"];
    },
    carRentalHistory() {
      return !this.isLoading && this.$store.getters["cars/getCarHistory"];
    },
  },
  methods: {
    getImgUrl(path) {
      return require("@/assets/images/" + path);
    },
    async fetchShifts() {
      this.isLoading = true;
      await this.$store.dispatch("cars/fetchSingle", this.$route.params.id);
      this.isLoading = false;
    },
    async fetchHistory() {
      this.isLoading = true;
      await this.$store.dispatch("cars/fetchCarHistory", this.$route.params.id);
      this.isLoading = false;
      this.totalRows = this.carRentalHistory.length;
    },
    loadMarkerCurrent() {
      const markerArea = new markerjs2.MarkerArea(this.$refs.imgRef);
      if (this.singleCar.damageChart) {
        let current = JSON.parse(this.singleCar.damageChart);
        markerArea.restoreState(current);
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async updateCar() {
      await this.$store.dispatch("cars/updateCar", {
        payload: this.singleCar,
        id: this.$route.params.id,
      });
    },
    showMarkerArea() {
      // create a marker.js MarkerArea
      const markerArea = new markerjs2.MarkerArea(this.$refs.imgRef);
      // attach an event handler to assign annotated image back to our image element
      markerArea.addRenderEventListener((dataUrl, state) => {
        this.$refs.imgRef.src = dataUrl;
        this.damageChart = JSON.stringify(state);
        this.$store.dispatch("cars/updateDamage", {
          id: this.$route.params.id,
          damageChart: this.damageChart,
        });
      });
      // launch marker.js
      markerArea.settings.displayMode = "popup";
      markerArea.show();
      if (this.singleCar.damageChart) {
        let current = JSON.parse(this.singleCar.damageChart);
        markerArea.restoreState(current);
      }
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
  width: 100%;
}
</style>
